module.exports = __webpack_public_path__ + "00_mole.050aa156.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer3/00_mole.png
// module id = MewM
// module chunks = 0